import { useEffect, useRef, useState } from 'react';

export default function Services() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      icon: 'ri-stethoscope-line',
      title: 'حالة مراجعة – زيارة واحدة',
      price: '460 ريال',
      description: 'فحص سمع مسحي جديد لتقييم السمع وإعادة ضبط الصوت للسماعة الحالية حسب الفحص الجديد',
      features: [
        'فحص سمع شامل',
        'تقييم احترافي',
        'إعادة برمجة السماعة',
        'استشارة مجانية'
      ]
    },
    {
      icon: 'ri-user-add-line',
      title: 'حالة جديدة – زيارتين',
      price: '575 ريال',
      description: 'خدمة متكاملة للحالات الجديدة تشمل زيارتين منزليتين مع فحص شامل واستشارات متخصصة',
      features: [
        'فحص سمع مسحي جديد',
        'استشارات حول السماعة المناسبة',
        'أخذ طبعة الأذن',
        'برمجة السماعة الجديدة',
        'إرشادات الاستخدام والعناية'
      ],
      featured: true
    }
  ];

  return (
    <section id="services" ref={sectionRef} className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div
            className={`inline-block bg-[#184187]/10 px-5 py-2 rounded-full mb-4 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <span className="text-[#184187] font-semibold text-sm">ماذا نقدم</span>
          </div>
          <h2
            className={`text-5xl md:text-6xl font-bold text-gray-900 mb-6 transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            خدماتنا
          </h2>
          <p
            className={`text-lg text-gray-600 transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            نقدم لك خدمات متكاملة لفحص السمع والسماعات الطبية في منزلك
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className={`rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden hover:-translate-y-2 ${
                service.featured
                  ? 'bg-[#184187] ring-2 ring-[#184187] transform md:scale-105'
                  : 'bg-white'
              } ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${(index + 1) * 200}ms` }}
            >
              {service.featured && (
                <div className="bg-white/20 text-white text-center py-2 text-sm font-medium">
                  الأكثر طلباً
                </div>
              )}
              
              <div className="p-8">
                <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 ${service.featured ? 'bg-white/20' : 'bg-[#184187]/10'}`}>
                  <i className={`${service.icon} text-3xl ${service.featured ? 'text-white' : 'text-[#184187]'}`}></i>
                </div>
                
                <h3 className={`text-2xl font-bold mb-3 ${service.featured ? 'text-white' : 'text-gray-900'}`}>{service.title}</h3>
                <div className={`text-3xl font-bold mb-4 ${service.featured ? 'text-white' : 'text-[#184187]'}`}>{service.price}</div>
                <p className={`mb-6 leading-relaxed ${service.featured ? 'text-white/90' : 'text-gray-600'}`}>{service.description}</p>
                
                <div className="space-y-3 mb-8">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <i className={`ri-check-line text-xl mt-0.5 ${service.featured ? 'text-white' : 'text-[#184187]'}`}></i>
                      <span className={`text-sm ${service.featured ? 'text-white/90' : 'text-gray-700'}`}>{feature}</span>
                    </div>
                  ))}
                </div>
                
                <button
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className={`w-full py-3 rounded-lg font-medium transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-lg ${
                    service.featured
                      ? 'bg-white text-[#184187] hover:bg-gray-100'
                      : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                  }`}
                >
                  احجز الآن
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
